var React = require('react');

function MobileAdd (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.9483 11.0039V19.0079C15.9483 19.7039 15.3843 20.2559 14.7003 20.2559H6.69629C6.00029 20.2559 5.44829 19.6919 5.44829 19.0079V5.00391C5.44829 4.30791 6.01229 3.75591 6.69629 3.75591H12.6963V2.00391H6.69629C5.04029 2.00391 3.69629 3.34791 3.69629 5.00391V19.0079C3.69629 20.6639 5.04029 22.0079 6.69629 22.0079H14.7003C16.3563 22.0079 17.7003 20.6639 17.7003 19.0079V11.0039H15.9483ZM11.7003 17.0039C11.7003 17.5559 11.2563 17.9999 10.7043 17.9999C10.1523 17.9999 9.70829 17.5559 9.70829 17.0039C9.70829 16.4519 10.1523 16.0079 10.7043 16.0079C11.2563 16.0079 11.7003 16.4519 11.7003 17.0039ZM15.8283 4.67991V2.00391H17.5803V4.67991H20.2923V6.43191H17.5803V9.10791H15.8283V6.43191H13.2003V4.67991H15.8283Z","fill":"black"}));
}

MobileAdd.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","className":"icon"};

module.exports = MobileAdd;

MobileAdd.default = MobileAdd;
